///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class PasswordResetFinishService {
    private readonly baseUrl = 'api/account';

    constructor(private readonly http: HttpClient) {}

    save(keyAndPassword: { key: string; newPassword: string }): Observable<unknown> {
        return this.http.post(`${this.baseUrl}/reset-password/finish`, keyAndPassword);
    }
}
